<template>
  <div :class="embedded ? '' : 'row'">
    <div :class="embedded ? '' : 'col-lg-12 col-xxl-12'">
      <div :class="embedded ? '' : 'card card-custom card-stretch gutter-b'">
        <div :class="embedded ? '' : 'card-body pb-10 pt-10 page-container'">
          <b-form @submit.stop.prevent="onSubmit()">
            <b-row class="mb-5">
              <b-col sm="2">
                <label>
                  <h5>
                    {{ $t("PAGE.CUSTOM_COLOR.FORM.FIELDS.BACKGROUND_COLOR") }}
                  </h5>
                </label>
              </b-col>
              <b-col sm="2">
                <b-form-input
                  id="background_color-input"
                  name="background_color-input"
                  type="color"
                  v-model="$v.form.background_color.$model"
                  :state="validateState('background_color')"
                  aria-describedby="background_color-live-feedback"
                ></b-form-input>
                <b-form-invalid-feedback id="background_color-live-feedback">
                  <span v-if="!$v.form.background_color.required" class="error">
                    {{ $t("PAGE.DEFAULT.FORM.VALIDATION.REQUIRED") }}
                  </span>
                </b-form-invalid-feedback>
              </b-col>
            </b-row>
            <b-row class="mb-5">
              <b-col sm="2">
                <label>
                  <h5>
                    {{ $t("PAGE.CUSTOM_COLOR.FORM.FIELDS.BUTTON_COLOR") }}
                  </h5>
                </label>
              </b-col>
              <b-col sm="2">
                <b-form-input
                  id="button_color-input"
                  name="button_color-input"
                  type="color"
                  v-model="$v.form.button_color.$model"
                  :state="validateState('button_color')"
                  aria-describedby="button_color-live-feedback"
                ></b-form-input>
                <b-form-invalid-feedback id="button_color-live-feedback">
                  <span v-if="!$v.form.button_color.required" class="error">
                    {{ $t("PAGE.DEFAULT.FORM.VALIDATION.REQUIRED") }}
                  </span>
                </b-form-invalid-feedback>
              </b-col>
            </b-row>
            <b-row class="mb-5">
              <b-col sm="2">
                <label>
                  <h5>
                    {{ $t("PAGE.CUSTOM_COLOR.FORM.FIELDS.BUTTON_TEXT_COLOR") }}
                  </h5>
                </label>
              </b-col>
              <b-col sm="2">
                <b-form-input
                  id="button_text_color-input"
                  name="button_text_color-input"
                  type="color"
                  v-model="$v.form.button_text_color.$model"
                  :state="validateState('button_text_color')"
                  aria-describedby="button_text_color-live-feedback"
                ></b-form-input>
                <b-form-invalid-feedback id="button_text_color-live-feedback">
                  <span
                    v-if="!$v.form.button_text_color.required"
                    class="error"
                  >
                    {{ $t("PAGE.DEFAULT.FORM.VALIDATION.REQUIRED") }}
                  </span>
                </b-form-invalid-feedback>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12">
                <b-button class="float-right" @click.prevent="cancel()">{{
                  $t("PAGE.DEFAULT.FORM.BTN_CANCEL")
                }}</b-button>
                <b-button
                  type="submit"
                  variant="primary"
                  class="float-right mr-3"
                >
                  {{ $t("PAGE.DEFAULT.FORM.BTN_SUBMIT") }}
                </b-button>
                <b-button
                  @click.prevent="preview()"
                  variant="warning"
                  class="float-right mr-3"
                >
                  {{ $t("PAGE.DEFAULT.FORM.BTN_PREVIEW") }}
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import {
  GET_CUSTOM_COLOR_BY_COMPANY,
  UPDATE_CUSTOM_COLOR_BY_COMPANY
} from "@/core/services/store/custom_color.module";
import Swal from "sweetalert2";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { Config } from "@/core/config/variable.config";
import { DEFAULT_COMPANY_CUSTOM_COLOR } from "@/core/config/defaultCompanyCustomColor";

export default {
  name: "CustomColor",
  mixins: [validationMixin],
  props: {
    companyId: { type: Number, default: null },
    embedded: { type: Boolean, default: false }
  },
  data() {
    return {
      form: { ...DEFAULT_COMPANY_CUSTOM_COLOR }
    };
  },
  validations: {
    form: {
      background_color: {
        required
      },
      button_color: {
        required
      },
      button_text_color: {
        required
      }
    }
  },
  computed: {
    ...mapState({
      currentUserData: (state) => state.auth.currentUserData
    }),
    effectiveCompanyId() {
      return this.companyId || this.currentUserData.company.id;
    }
  },
  mounted() {
    if (!this.embedded) {
      this.$store.dispatch(SET_BREADCRUMB, [
        { title: `${this.$t("MENU.CUSTOM_COLOR")}` }
      ]);
    }
    this.getCustomColorData();
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    getCustomColorData() {
      this.$store
        .dispatch(GET_CUSTOM_COLOR_BY_COMPANY, {
          company_id: this.effectiveCompanyId
        })
        .then(({ data }) => {
          if (data.status === "success" && data.data) {
            this.form.background_color = data.data.background_color;
            this.form.button_color = data.data.button_color;
            this.form.button_text_color = data.data.button_text_color;
          } else if (data.status === "error" && data.error) {
            if (data.error === "DATA_NOT_FOUND") {
              Object.assign(this.form, DEFAULT_COMPANY_CUSTOM_COLOR);
            } else {
              Swal.fire({
                icon: "error",
                text: this.$t("RESPONSE_MESSAGE." + data.error),
                confirmButtonText: this.$t("PAGE.DEFAULT.FORM.BTN_OK")
              });
            }
          }
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            text: `${error}`,
            confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
          });
        });
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      this.update(this.form, this.effectiveCompanyId);
    },
    update(data, id) {
      Swal.fire({
        title: `${this.$t("LOADING")}`,
        allowEscapeKey: false,
        allowOutsideClick: false,
        timer: 36000,
        onOpen: () => {
          Swal.showLoading();
          this.$store
            .dispatch(UPDATE_CUSTOM_COLOR_BY_COMPANY, { company_id: id, data })
            .then(({ data }) => {
              Swal.close();
              if (data.status === "success" && data.data) {
                Swal.fire({
                  icon: "success",
                  text: this.$t("RESPONSE_MESSAGE.SAVE_DATA_SUCCESS")
                });
                this.$v.$reset();
              } else if (data.status === "error" && data.error) {
                Swal.fire({
                  icon: "error",
                  text: this.$t("RESPONSE_MESSAGE." + data.error),
                  confirmButtonText: this.$t("PAGE.DEFAULT.FORM.BTN_OK")
                });
              }
            })
            .catch((error) => {
              Swal.close();
              Swal.fire({
                icon: "error",
                text: error,
                confirmButtonText: this.$t("PAGE.DEFAULT.FORM.BTN_OK")
              });
            });
        }
      });
    },
    cancel() {
      this.$v.$reset();
      this.getCustomColorData();
    },
    preview() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      window.open(
        `${
          Config.SWEEPSTAKES_LIFF_CLIENT_URL
        }/default/form/?is_preview=true&background_color=${this.form.background_color.substring(
          1
        )}&button_color=${this.form.button_color.substring(
          1
        )}&button_text_color=${this.form.button_text_color.substring(1)}`,
        `_blank`,
        `
          top=10,
          left=10,
          width=375,
          height=667
        `
      );
    }
  }
};
</script>
